import { motion } from "framer-motion";
import { MapPin, Clock, MessageCircle, Heart } from "lucide-react";
import { waGeneral, WA_DISPLAY } from "@/lib/whatsapp";

export default function About() {
  return (
    <section id="nosotros" className="py-20 lg:py-28 bg-paper border-b-2 border-ink relative grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <span className="font-mono text-xs uppercase tracking-[0.2em] font-bold text-kpink">Nosotros</span>
          <h2 className="font-display font-extrabold tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-2 leading-tight">
            Una librería con corazón kuki
          </h2>
          <p className="text-ink/70 mt-5 font-medium leading-relaxed">
            En <strong>Kuki Impresiones</strong> amamos la papelería tanto como vos. Elegimos cada producto
            pensando en ese momento en que un cuaderno nuevo, unos marcadores de colores o un regalo
            sorpresa te sacan una sonrisa.
          </p>
          <p className="text-ink/70 mt-4 font-medium leading-relaxed">
            Atendemos en nuestro local de Luque y enviamos a todo el país. Escribinos por WhatsApp,
            contanos qué necesitás y lo preparamos con todo el cariño del mundo.
          </p>
          <div className="inline-flex items-center gap-2 mt-6 bg-kpink/10 border-2 border-kpink text-kpink rounded-full px-4 py-2 font-bold text-sm">
            <Heart size={16} strokeWidth={2.5} fill="currentColor" /> Hecho con amor en Luque
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: 0.15 }}
          className="space-y-4">
          <div className="bg-white border-2 border-ink rounded-3xl p-6 shadow-neo flex gap-4" data-testid="about-location-card">
            <div className="h-12 w-12 shrink-0 grid place-items-center rounded-2xl border-2 border-ink bg-kyellow">
              <MapPin size={22} strokeWidth={2.5} />
            </div>
            <div>
              <h3 className="font-display font-bold text-lg">Dónde estamos</h3>
              <p className="text-ink/70 font-medium">Fotógrafos del Chaco c/ San Juan</p>
              <p className="text-ink/70 font-medium">Ciudad de Luque, Paraguay</p>
            </div>
          </div>

          <div className="bg-white border-2 border-ink rounded-3xl p-6 shadow-neo-cyan flex gap-4" data-testid="about-hours-card">
            <div className="h-12 w-12 shrink-0 grid place-items-center rounded-2xl border-2 border-ink bg-kcyan">
              <Clock size={22} strokeWidth={2.5} />
            </div>
            <div>
              <h3 className="font-display font-bold text-lg">Horarios de atención</h3>
              <p className="text-ink/70 font-medium">Lunes a Sábado: 08:30 — 19:00</p>
              <p className="text-ink/70 font-medium">Domingos: 10:00 — 14:00</p>
            </div>
          </div>

          <div className="bg-white border-2 border-ink rounded-3xl p-6 shadow-neo-pink flex gap-4 items-center" data-testid="about-contact-card">
            <div className="h-12 w-12 shrink-0 grid place-items-center rounded-2xl border-2 border-ink bg-[#25D366] text-white">
              <MessageCircle size={22} strokeWidth={2.5} />
            </div>
            <div className="flex-1">
              <h3 className="font-display font-bold text-lg">WhatsApp directo</h3>
              <p className="text-ink/70 font-medium">{WA_DISPLAY}</p>
            </div>
            <a href={waGeneral()} target="_blank" rel="noopener noreferrer" data-testid="about-whatsapp-cta"
              className="h-11 px-5 inline-flex items-center rounded-full border-2 border-ink bg-kyellow font-bold text-sm shadow-neo-sm hover:-translate-y-0.5 transition-transform">
              Escribir
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
